import React from 'react';
import { ReactComponent as ErrorIcon } from '@crazyegginc/hatch/dist/images/icon-cross-circle-filled.svg';

import { RenderInfos } from './RenderInfos';
import { VerticalLine } from './VerticalLine';

function DefaultCard({ children }) {
  return (
    <div className="mt-10 flex h-full w-full rounded-md bg-alice-blue-500 px-[30px] pb-10 pt-[30px]">{children}</div>
  );
}

export function ErrorItem({
  title,
  description,
  suggestion = null,
  children,
  consoleErrors = null,
  CardComponent = DefaultCard,
  ui = {},
}) {
  const {
    titleClassName = '',
    descriptionClassName = '',
    iconClassName = '',
    iconContainerClassName = '',
    contentClassName = '',
    suggestionClassName = 'text-body-2 mt-2.5',
    suggestionStrongClassName = 'text-body-1',
  } = ui;

  return (
    <CardComponent>
      <div className={`relative mr-[25px] w-10 flex-shrink-0 ${iconContainerClassName}`.trim()}>
        <div className="rounded-full bg-white">
          <ErrorIcon
            className={`h-10 w-10 fill-current text-carnation-500 ${iconClassName}`.trim()}
            aria-label="error"
          />
        </div>
        {consoleErrors?.length ? <VerticalLine /> : null}
      </div>
      <div className={`min-w-0 flex flex-col items-start ${contentClassName}`.trim()}>
        <h3 className={`text-header-4 mb-2.5 leading-none ${titleClassName}`.trim()}>{title}</h3>
        <p className={`text-body-2 leading-snug ${descriptionClassName}`.trim()}>{description}</p>
        {suggestion && (
          <div className={suggestionClassName}>
            <strong className={suggestionStrongClassName}>How to fix it:</strong> {suggestion}
          </div>
        )}
        {children}
        <RenderInfos consoleErrors={consoleErrors} />
      </div>
    </CardComponent>
  );
}
